import { gql } from '@apollo/client'
import { useState, useEffect } from 'react'
import { Alert, Input } from 'reactstrap'
import { FILE_LIST_QUERY } from '../../../graphql'
import { handleGraphQLErrors } from '../../../utils'
import Spinner from '../../Spinner/Spinner'

export const FILE_LIST = gql(FILE_LIST_QUERY)

export default function FileSelect(props) {
  console.log('FileSelect rendered: ', props)
  const { field, handleChange } = props

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        let { data, errors } = await window.apolloClient.query({ query: FILE_LIST, variables: { fieldId: field.id, fileTypeId: field.maxLength } })
        console.log(data, errors)
        if (errors) {
          setGraphQLErrors(errors)
        }
        if (data.fileList) {
          const menuItems = [<option key={0} value={''}></option>]
          for (let item of data.fileList) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
        }
      } catch (err) {
        console.log(err)
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [items, field])

  if (graphQLErrors.length > 0) {
    return <Alert color='danger'>{graphQLErrors[0].message}</Alert>
  } else if (items) {
    return (
      <Input style={{ width: 'auto', margin: 'auto' }} type="select" bsSize="sm" name={field.id} onChange={handleChange}>
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
